import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./App";
import { getPermissionsForComponent, ROLE_BASED_ROUTES } from "./Constants/RolesConstants";

const ProtectedRoute = ({ Component, componentName }) => {
  const { isUserAuthenticated, userRole } = useContext(AuthContext);
  if (!isUserAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const routesAccessibleToRole = ROLE_BASED_ROUTES[userRole] || [];
  const hasRequiredRole = routesAccessibleToRole.includes(componentName);
  const permissions = getPermissionsForComponent(componentName);

  //TODO: add sub-component level checking
  // const hasPermission = permissions && permissions[componentName].canViewMenu;

  return hasRequiredRole ? (
    <Component permissions={permissions} userRole={userRole} />
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default ProtectedRoute;
